import { InternalLogger } from './InternalLogger';
import { LoggerInterface, LoggerOptions } from './loggerModels';
export class ConsoleLoggerAdapter implements LoggerInterface {
  constructor(private attributes?: Record<string, any>) {}

  private merge(attributes?: Record<string, any>): Record<string, any> {
    return {
      ...this.attributes,
      ...attributes,
    };
  }

  child(attributes: Object, loggerOptions: LoggerOptions): LoggerInterface {
    return new InternalLogger(new ConsoleLoggerAdapter(this.merge(attributes)), loggerOptions);
  }

  info(message: string, attributes?: Object): void {
    this.emitLogMessage('info', message, attributes);
  }

  warn(message: string, attributes?: Object): void {
    this.emitLogMessage('warn', message, attributes);
  }

  error(message: string, attributes?: Object): void {
    this.emitLogMessage('error', message, attributes);
  }

  fatal(message: string, attributes?: Object): void {
    this.emitLogMessage('error', message, attributes);
  }

  silly(message: string, attributes?: Object): void {
    this.emitLogMessage('info', message, attributes);
  }
  trace(message: string, attributes?: Object): void {
    this.emitLogMessage('info', message, attributes);
  }

  debug(message: string, attributes?: Object): void {
    this.emitLogMessage('debug', message, attributes);
  }

  log(message: string, attributes?: Object): void {
    this.emitLogMessage('log', message, attributes);
  }

  private emitLogMessage(
    logType: 'info' | 'error' | 'debug' | 'warn' | 'log',
    message: string,
    attributes?: Object,
  ): void {
    attributes || this.attributes ? console[logType](message, this.merge(attributes)) : console[logType](message);
  }
}
